<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
    <md-card>
      <!-- <div class="md-layout-item md-size-33 md-small-size-100">
                  <h5>Vehicle No</h5>
                  <md-radio v-model="radio" :value="1">Baik</md-radio>
                  <md-radio v-model="radio" :value="2">Tidak Baik/Rusak</md-radio><br/>
                  <md-radio v-model="radio" :value="3">Hilang</md-radio>
                  <md-radio v-model="radio" :value="4">N/A</md-radio>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
              <validation-provider rules="vehicle" ref="checker_vehicle_door_text" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Vehicle No</label>
                  <md-input />
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div> -->
      <md-card-content>
        <!-- <h4>Bagian Dalam/Interior</h4> -->

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>AC/Merk</h5>
            <md-radio v-model="checker.checker_ac" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_ac" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_ac" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_ac" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_ac_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Central Lock</h5>
            <md-radio v-model="checker.checker_central_lock" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_central_lock" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_central_lock" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_central_lock" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_central_lock_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Elektrik Mirror</h5>
            <md-radio v-model="checker.checker_elektrik_mirror" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_elektrik_mirror" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_elektrik_mirror" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_elektrik_mirror" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_elektrik_mirror_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Head Rest/Sandaran Kepala</h5>
            <md-radio v-model="checker.checker_head_rest" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_head_rest" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_head_rest" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_head_rest" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_head_rest_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Karpet Dasar</h5>
            <md-radio v-model="checker.checker_karpet_dasar" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_karpet_dasar" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_karpet_dasar" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_karpet_dasar" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_karpet_dasar_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Karpet Karet</h5>
            <md-radio v-model="checker.checker_karpet_karet" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_karpet_karet" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_karpet_karet" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_karpet_karet" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_karpet_karet_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Klakson</h5>
            <md-radio v-model="checker.checker_posisi_stir_dan_klakson" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_posisi_stir_dan_klakson" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_posisi_stir_dan_klakson" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_posisi_stir_dan_klakson" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_posisi_stir_dan_klakson_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_posisi_stir_dan_klakson"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kunci Utama</h5>
            <md-radio v-model="checker.checker_kunci" :value="1">Ada</md-radio>
            <md-radio v-model="checker.checker_kunci" :value="2">Tidak Ada</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kunci_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kunci Cadangan</h5>
            <md-radio v-model="checker.checker_kunci_cadangan" :value="1">Ada</md-radio>
            <md-radio v-model="checker.checker_kunci_cadangan" :value="2">Tidak Ada</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kunci_cadangan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Sign</h5>
            <md-radio v-model="checker.checker_lampu_sign" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_sign" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_sign" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_sign" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_sign_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Baca</h5>
            <md-radio v-model="checker.checker_lampu_baca" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_baca" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_baca" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_baca" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_baca_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Utama Depan</h5>
            <md-radio v-model="checker.checker_lampu_utama_depan" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_utama_depan" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_utama_depan" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_utama_depan" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_utama_depan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Rem</h5>
            <md-radio v-model="checker.checker_lampu_rem" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_rem" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_rem" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_rem" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_rem_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lampu Mundur</h5>
            <md-radio v-model="checker.checker_lampu_mundur" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lampu_mundur" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lampu_mundur" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lampu_mundur" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lampu_mundur_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>MCCS</h5>
            <md-radio v-model="checker.checker_mccs" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_mccs" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_mccs" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_mccs" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_mccs_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Pedal Kopling/Rem/Gas</h5>
            <md-radio v-model="checker.checker_pedal" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_pedal" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_pedal" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_pedal" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_pedal_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Putaran Mesin</h5>
            <md-radio v-model="checker.checker_putaran_mesin" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_putaran_mesin" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_putaran_mesin" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_putaran_mesin" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_putaran_mesin_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Power Window</h5>
            <md-radio v-model="checker.checker_power_window" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_power_window" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_power_window" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_power_window" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_power_window_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Rem Tangan</h5>
            <md-radio v-model="checker.checker_rem_tangan" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_rem_tangan" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_rem_tangan" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_rem_tangan" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_rem_tangan_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Radio/Tape/CD</h5>
            <md-radio v-model="checker.checker_head_unit" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_head_unit" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_head_unit" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_head_unit" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_head_unit_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Remote Tape</h5>
            <md-radio v-model="checker.checker_remote_head_unit" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_remote_head_unit" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_remote_head_unit" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_remote_head_unit" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_remote_head_unit_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        

        

        <!-- <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Kartu Oli dan Maintenance</h5>
            <md-radio v-model="checker.checker_kartu_oli_dan_maintenance" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_kartu_oli_dan_maintenance" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_kartu_oli_dan_maintenance" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_kartu_oli_dan_maintenance" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_kartu_oli_dan_maintenance_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div> -->  

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>STNK</h5>
            <md-radio v-model="checker.checker_stnk" :value="1">Ada</md-radio>
            <md-radio v-model="checker.checker_stnk" :value="2">Hilang</md-radio>
            <md-radio v-model="checker.checker_stnk" :value="3">Tilang</md-radio>
            <md-radio v-model="checker.checker_stnk" :value="4">Perpanjang STNK</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_stnk_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <!-- <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Lighter /Pemantik</h5>
            <md-radio v-model="checker.checker_lighter" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_lighter" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_lighter" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_lighter" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_lighter_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div> -->

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Safety Belt</h5>
            <md-radio v-model="checker.checker_safety_belt" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_safety_belt" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_safety_belt" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_safety_belt" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_safety_belt_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        

        

        

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Sarung Jok</h5>
            <md-radio v-model="checker.checker_sarung_jok" :value="1">Ada</md-radio>
            <md-radio v-model="checker.checker_sarung_jok" :value="2">Tidak Ada</md-radio>
            <md-radio v-model="checker.checker_sarung_jok" :value="3">Rusak</md-radio>
            <md-radio v-model="checker.checker_sarung_jok" :value="4">Robek</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_sarung_jok_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        

        <!-- <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Asbak (depan/belakang) </h5>
            <md-radio v-model="checker.checker_asbak_depan_belakang" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_asbak_depan_belakang" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_asbak_depan_belakang" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_asbak_depan_belakang" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_asbak_depan_belakang_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div> -->

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Speedometer</h5>
            <md-radio v-model="checker.checker_speedometer" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_speedometer" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_speedometer" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_speedometer" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_speedometer_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-medium-size-50 md-small-size-100">
            <h5>Wiper (Depan/Belakang)</h5>
            <md-radio v-model="checker.checker_wiper_depan_belakang" :value="1">Baik</md-radio>
            <md-radio v-model="checker.checker_wiper_depan_belakang" :value="2">Tidak Baik/Rusak</md-radio>
            <md-radio v-model="checker.checker_wiper_depan_belakang" :value="3">Hilang</md-radio>
            <md-radio v-model="checker.checker_wiper_depan_belakang" :value="4">N/A</md-radio>
            <validation-error
                :errors="apiValidationErrors.checker_vehicle_door_text"
              />
          </div>
            
          <div class="md-layout-item md-medium-size-50 md-small-size-100" style="margin-top:40px;">

              <validation-provider  v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Remark</label>
                  <md-input v-model="checker.checker_wiper_depan_belakang_remark"/>
                  <validation-error
                    :errors="apiValidationErrors.checker_vehicle_door_text"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
          </div>
        </div>
        <div class="md-layout-item">
          <autoextra :collection="photo" v-slot="{item,last,index}">
            <div  :class="{last: last}">
              <div v-if="item.photo_attach_view || item.url_photo_file || item.photo_remark || last" class="columns">
                <label :id="'labelAccesoriesFlag_'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Photo {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                  
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  

                  <div class="md-layout-item md-small-size-100">
                    <label class="md-layout-item md-size-15 md-form-label">Upload File/Photo</label>
                    <md-field class="md-invalid">
                      <md-file 
                      ref="stnk"
                        @change="on_change_attach_photo(item.photo_attach_view,index)"
                        v-model="item.photo_attach_view"
                        accept="image/jpeg,image/png"
                      />
                      <validation-error
                        :errors="apiValidationErrors.photo_attach"
                      />
                    </md-field>
                    <p v-if="item.photo_attach && item.photo_attach.type != 'image/jpeg' && item.photo_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.photo_attach.size / 1048576).toFixed(2) }}MB</p>
                  </div>
                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-textarea v-model="item.photo_remark" md-counter="150" maxlength="150" :disabled="!item.photo_attach_view && item.photo_attach_view != 0" md-autogrow></md-textarea>
                    </md-field>
                  </div>
                  </div>

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">

                    <div class="border p-2 mt-3">
                      <template v-if="item.photo_attach">
                        <viewer class="pointer">
                        <img style="width: auto; max-height:400px; display: block; margin:auto;"
                          :src="item.photo_attach.base64"
                          class="img-fluid"
                        />
                        </viewer>
                        <!-- <p class="mb-0">file name: {{ file_attach_accesories.name }}</p> -->
                        <p class="mb-0">size: {{ (item.photo_attach.size / 1048576).toFixed(2) }}MB</p>
                      </template>
                      <template v-if="!item.photo_attach && item.url_photo_file">
                      <!-- <template v-if="!file_attach_accesories && item.url_photo_file"> -->
                        <template>
                          <span style="color:green"
                            >Current Photo:
                          </span>
                          <viewer class="pointer">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;"
                              :src="item.url_photo_file"
                              
                              class="img-fluid"
                            />
                          </viewer>
                        </template>
                      </template>
                    </div>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.photo_attach_view || item.photo_attach_view==0 || item.photo_remark || item.url_photo_file">
                    delete
                  </md-button>
                  </md-card-actions>
                </div>            
              </div>
            </div>
            </autoextra>
          </div>
            
        
      </md-card-content>
    </md-card>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
import ListVehicle from "@/pages/Dashboard/Workshop/Checker/Modal/ListVehicle.vue";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';
import  Autoextra  from 'vue-autoextra';


  
  export default {
     name: "add-checker",

    props: ["checker"],

    components: {ValidationError,Autoextra },

    mixins: [formMixin],

    data: () => ({
      photo:[],
      // checker_kunci:null,
      // checker_kunci_remark:null,
      // checker_putaran_mesin:null,
      // checker_putaran_mesin_remark:null,
      // checker_rem_tangan:null,
      // checker_rem_tangan_remark:null,
      // checker_pedal: null,
      // checker_pedal_remark: null,
      // checker_posisi_stir_dan_klakson:null,
      // checker_posisi_stir_dan_klakson_remark:null,
      // checker_kartu_oli_dan_maintenance:null,
      // checker_kartu_oli_dan_maintenance_remark:null,
      // checker_wiper_depan_belakang:null,
      // checker_wiper_depan_belakang_remark:null,
      // checker_lampu_sign:null,
      // checker_lampu_sign_remark:null,
      // checker_lampu_baca:null,
      // checker_lampu_baca_remark:null,
      // checker_lampu_utama_depan:null,
      // checker_lampu_utama_depan_remark:null,
      // checker_lampu_rem:null,
      // checker_lampu_rem_remark:null,
      // checker_lampu_mundur:null,
      // checker_lampu_mundur_remark:null,
      // checker_power_window:null,
      // checker_power_window_remark:null,
      // checker_central_lock:null,
      // checker_central_lock_remark:null,
      // checker_elektrik_mirror:null,
      // checker_elektrik_mirror_remark:null,
      // checker_ac:null,
      // checker_ac_remark:null,
      // checker_stnk:null,
      // checker_stnk_remark:null,
      // checker_lighter:null,
      // checker_lighter_remark:null,
      // checker_safety_belt:null,
      // checker_safety_belt_remark:null,
      // checker_head_rest:null,
      // checker_head_rest_remark:null,
      // checker_head_unit:null,
      // checker_head_unit_remark:null,
      // checker_remote_head_unit:null,
      // checker_remote_head_unit_remark:null,
      // checker_mccs:null,
      // checker_mccs_remark:null,
      // checker_sarung_jok:null,
      // checker_sarung_jok_remark:null,
      // checker_karpet_dasar:null,
      // checker_karpet_dasar_remark:null,
      // checker_karpet_karet:null,
      // checker_karpet_karet_remark:null,
      // checker_asbak_depan_belakang:null,
      // checker_asbak_depan_belakang_remark:null,
      // checker_speedometer:null,
      // checker_speedometer_remark:null,
    }),


  // created() {
  //         this.getListNota();
  //     },

  
    methods: {
      on_change_attach_photo(event,index) {
        console.log(index)
      var input = event.target;
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          // this.resetFile('photo_driver')
          // this.photo_attach = null
          // this.photo_attach = null
          console.log(input)
          this.$set(this.photo, index, {
                  id : this.photo[index].id,
                  photo_remark : this.photo[index].photo_remark,
                  photo_attach : null,
                  photo_attach_view : null,
                  url_photo_file : this.photo[index].url_photo_file,
                  photo_remark : this.photo[index].photo_remark
                  
                });

          
          //console.log(this.photo_attach)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          //this.photo_attach = fileData;
             console.log(this.photo[index]);
             if(this.photo[index]){
               this.$set(this.photo, index, {
                  id : this.photo[index].id,
                  photo_attach : fileData,
                   photo_attach_view : fileData.name,
                  url_photo_file : this.photo[index].url_photo_file,
                  photo_remark : this.photo[index].photo_remark
                  
                });
             }
             else{
               this.$set(this.photo, index, {
                  id : null,
                  photo_attach : fileData,
                   photo_attach_view : fileData.name,
                  url_photo_file : null,
                  photo_remark : null
                  
                });
             }
           

        };
        reader.readAsDataURL(input.files[0]);
    
      }
    },

   sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },

    deleteColumn(index){
        if (index > -1) {
           this.photo.splice(index, 1)
            var filtered = this.photo.filter(function (el) {
              return el != null;
            });
            this.photo = filtered;
        }
        
      },


    getData() {
        this.checker['images_bagian_dalam'] = this.photo
        this.$emit('data', this.checker)
       
    },

    async getDataParent() {
      //this.photo = this.checker.checker_image_bagian_dalam
      this.checker.checker_image_bagian_dalam.forEach((value, index) => {

        //set data spare part dari data sparepart
        this.$set(this.photo, index, {
                  id : value.id,
                  photo_attach : null,
                   photo_attach_view : null,
                  url_photo_file : value.url_photo_file,
                  photo_remark : value.photo_remark
                  
                });
      });
      console.log(this.photo)
    },
  }
};
</script>
